export const environment = {
  production: false,
  encryption: false,
  ENCRIPTION_KEY: 'bba3c6560756c7cbbb3c04ae0ba928ac',
  ENCRIPTION_IV: 'RagHqstop2ZYrGRZ',
  API_URL: 'https://portal.hubiz.app/booking_tool/',
  AUTH_API: "https://portal.hubiz.app/",
  FILE_URL: "https://portal.hubiz.app/",
  SOCKET_URL: "https://socket.hubiz.app/",
  DEFAULT_PHONE: '+32',
  powerBy: 'Hubiz',
  GOOGLE_PLACES_API_KEY: '', // Add your Google Places API key here

  // Trip Api
  'Booking Tool': {
    settingDetails: 'setting_details',
    requestPayment: 'requestPayment',
    submitStripe: 'submit_stripe',
    submitIdeal: 'submit_ideal',
    tripDetails: 'trip-detail',
    cancel: 'set-trip-status',
    complete: 'completeBookingTool',
    search: 'search',
    searchAll: 'partner-list-against-price',
    create: 'create-trip',
    openQr: 'open_company_qr/',
  },
};
